import request from "../plugins/axios";


export function trafficRecharge(data) {
	return request({
		url: '/scrm/tenantRedMoneyEwmRechargeApplyLogAdd',
		method: 'POST',
		data
	})
}

export function trafficRechargeList(data) {
    return request({
        url: '/scrm/tenantRedMoneyEwmRechargeApplyLogList',
        method: 'POST',
        data
    })
}

export function trafficUploadImage(data) {
    return request({
        url: '/scrm/uploadImgCommon',
        method: 'POST',
        data
    })
}
// 支付充值  获取充值档位
export function getRechargeList(){
    return request({
        url:"/scrm/tenantRedMoneyEwmRechargeApplyLogConfig",
        method:"POST"
    })
}
// 支付充值 - 获取充值URL
export function trafficRechargePay(data) {
    return request({
        url: '/scrm/trafficRechargePay',
        method: 'POST',
        data
    })
}